import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import loadingDark from "@/assets/loading-dark.png";
import loadingLight from "@/assets/loading-light.png";

export const LoadingScreen = () => {
  const [isVisible, setIsVisible] = useState(true);
  const { resolvedTheme } = useTheme();

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  const logoSrc = resolvedTheme === "light" ? loadingLight : loadingDark;

  return (
    <div className="fixed inset-0 z-[100] bg-background flex items-center justify-center animate-fade-out">
      <div className="flex flex-col items-center gap-6">
        <div className="relative animate-[float_3s_ease-in-out_infinite]">
          {/* Animated circles */}
          <div className="absolute inset-0 animate-[spin_3s_linear_infinite]">
            <div className="w-32 h-32 rounded-full border-4 border-primary/20 border-t-primary"></div>
          </div>
          
          {/* Logo */}
          <div className="w-32 h-32 rounded-full flex items-center justify-center animate-scale-in">
            <img 
              src={logoSrc} 
              alt="sksenq logo" 
              className="w-24 h-24 object-contain"
            />
          </div>
        </div>
        
        {/* Text */}
        <div className="text-center animate-fade-in space-y-2">
          <p className="text-muted-foreground text-sm">Tools for building software with AI</p>
        </div>
      </div>
    </div>
  );
};
